import React from 'react';

const SvgMap = ({ svgRef, title, ...props }) => (
  <svg width="1em" height="1em" viewBox="0 0 22 23" ref={svgRef} {...props}>
    <title>{title}</title>
    <path fill="#fff" d="M3 17.45V4.64l3.001 1.07v12.82zM9 5.53L12.501 4v12.73L9 18.26zm6.5 10.93V3.63L19 4.82v12.83zM14.161 0L7.31 3 0 .38v19.181l7.42 2.659 6.88-3 7.7 2.61V2.669z"/>
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgMap svgRef={ref} {...props} />);
export default ForwardRef;



// WEBPACK FOOTER //
// ./src/common/icons/Map.js